import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalContenido } from '../interface/modal-contenido.interface';

@Component({
  selector: 'app-modal-generico',
  templateUrl: './modal-generico.component.html',
  styleUrls: ['./modal-generico.component.scss']
})
export class ModalGenericoComponent implements OnInit {
  
  contenido : ModalContenido = {
    titulo: null,
    cuerpoParrafo1: null,
    cuerpoParrafo2: null,
    cuerpoParrafo3: null,
    cuerpoParrafo4: null,
    icono:null,
    input:null,
    select: null,
    botonAceptar: null,
    botonCancelar: null,
    icoAlert : false,
    icoInf: false,
    icoError: false
  } 
  
  constructor(public dialogRef: MatDialogRef<ModalGenericoComponent>,
              @Inject(MAT_DIALOG_DATA) public data,) { }

  ngOnInit(): void {
    this.contenido = this.data;
    console.log(this.data)
    console.log(this.contenido);
    
  }

}
